import React from "react";
const AuthContext = React.createContext(null);
function AuthProvider({ children }) {
  const [user, setUser] = React.useState(null);
  const [session, setSession] = React.useState(null);
  const [userTeamMemberships, setUserTeamMemberships] = React.useState(null)
  const values = {
    user,
    setUser,
    session,
    setSession,
    userTeamMemberships,
    setUserTeamMemberships
  };
  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
}


export { AuthContext, AuthProvider };
